import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';

const phone =
  (import.meta.env?.VITE_BRIDE_WHATSAPP as string | undefined) ?? '13059240847';

export default function QrBlock() {
  const { t } = useTranslation();
  if (!phone) return null;

  const message = encodeURIComponent(t('confirmations.whatsappMessage'));
  const href = `https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${message}`;

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="bg-white p-3 rounded-md shadow-card">
        <QRCodeSVG
          value={href}
          size={140}
          bgColor="#FFFFFF"
          fgColor="#2E2A26"
          level="L"
          includeMargin={false}
          aria-label="WhatsApp QR code"
          role="img"
        />
      </div>
      <p className="max-w-[220px] text-[0.7rem] tracking-widest font-sans text-center text-brand-ink/70 uppercase leading-snug">
        {t('footer.qrCaption')}
      </p>
    </div>
  );
}
